import React from 'react'

import Form from './Form/ButtonsForm'

import { Buttons } from '@peracto/peracto-blocks-tailwind'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    const RenderComponent = Buttons

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/buttons',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            buttons: [],
            selectedButtonIndex: 0,
        }),
    }
}

export default createPlugin
